/* eslint-disable @typescript-eslint/no-explicit-any */
// import EventVideos30Days from 'assets/luna/30DaysEventVideos.png';
// import LimitedSecurity from 'assets/luna/limitedSecurity.png';
// import NoEventVideos from 'assets/luna/noEventVideos.png';
// import LunaAllCamerasAddedToAccount from 'assets/luna/AllCamerasAddedToAccount.svg';
// import LunaCannotAddSelectedCamera from 'assets/luna/CannotAddSelectedCamera.svg';
// import LunaFreeTrialActivated from 'assets/luna/FreeTrialActivated.svg';
// import LunaAppLandingLogo from 'assets/luna/loginIllustration.svg';
// import LunaAppLogo from 'assets/luna/logo.svg';
// import LunaBasicAlerts from 'assets/luna/basicMotionAlerts.png';
// import LunaDescriptiveAlerts from 'assets/luna/descriptiveAlerts.png';
// import LunaSmallWhiteLogo from 'assets/luna/logoWhite.png';
// import LunaProfessionalMonitoring from 'assets/luna/professionalMonitoring.png';
// import LunaPaymentDeclined from 'assets/luna/PaymentDeclined.svg';
// import LunaPaymentSuccessful from 'assets/luna/PaymentSuccessful.svg';
import { TFunction } from 'i18next';
import { TPartnerConfigurationDetails } from 'typings/partner';
// import { partnerAssets } from 'partners/partnersAssets';
import { DEFAULT_TRANSLATIONS } from '../../utils/translationFunctions';

// Create a function that returns the config and accepts an optional translation function
export const getLunaConfig = (t?: TFunction): TPartnerConfigurationDetails => {
  // Use either the passed translation function or default to build-time values
  const translations = DEFAULT_TRANSLATIONS.luna;

  // Handle translation with fallbacks to build-time defaults
  const translate = (
    key: string,
    options?: object,
    fallback?: string
  ): string => {
    if (t) {
      try {
        const translation = t(key, options as any);
        return translation !== key
          ? translation
          : fallback || translations[key as keyof typeof translations] || key;
      } catch (error) {
        console.warn(`Translation failed for key: ${key}`, error);
        return (
          fallback || translations[key as keyof typeof translations] || key
        );
      }
    }
    return translations[key as keyof typeof translations] || fallback || key;
  };

  return {
    nameOfCompany: 'Luna Home',
    typeOfCompany: 'LLC.',
    singinLabel: translate('signIn', undefined, 'Sign In') as string,
    welcomeText: translate(
      'welcomeText',
      {
        partnerName: 'Luna AI'
      },
      'Welcome to Luna AI'
    ) as string,
    // loginIllustration: partnerAssets.loginIllustration,
    // logo: partnerAssets.logo,
    universalLink: process.env.REACT_APP_UNIVERSAL_LINK,
    // paymentSuccessfull: partnerAssets.paymentSuccessfulIcon,
    // paymentFailed: partnerAssets.paymentFailedIcon,
    // multiCameraAddedIllustration: partnerAssets.AllCamerasAddedToAccountIcon,
    // cannotAddDeviceIcon: partnerAssets.CannotAddSelectedCameraIcon,
    // trialActivationIcon: partnerAssets.FreeTrialActivatedIcon,
    label: 'Luna AI',
    // supportEmail: 'support@lunahomeai.com',
    supportEmail: 'lunasupport@lunahome.com',
    supportEmail2: 'lunasupport@lunahome.com',
    phoneNumber: '+1 (855) 604-5862',
    companyAddress: '450 North 1500 West Orem, Utah 84057',
    // freeTrialLivingRoom: EventVideos30Days,
    // freeTrialPersonDetected: partnerAssets.descriptiveAIAlertsImg,
    // freeTrialCriticalAlerts: partnerAssets.professionalMonitoringImg,
    // skipFreeTrialLivingRoom: partnerAssets.noEventVideosImg,
    // skipFreeTrialTheft: partnerAssets.limitedSecurityImg,
    // skipFreeTrialFalseAlerts: partnerAssets.basicMotionAlertsImg,
    updateDeteOfPrivacyPolicy: 'September 11, 2024',
    updateDeteOfTermsOfService: 'September 11, 2024',
    // smallWhiteLogo: partnerAssets.logoWhiteIcon,
    promo30DaysEventVideoId: 't3TcEt0eCps',
    promoDescriptiveAlertsVideoId: 'boee6zuJyME',
    promoProfessionMonitoringVideoId: '7_86vVJ4wEg',
    iosAppLink: 'https://apps.apple.com/us/app/luna-ai/id6511216510',
    androidAppLink:
      'https://play.google.com/store/apps/details?id=com.lunahomeai.homesecurity'
  };
};

// Export a static config for bundling/tree-shaking
const lunaConfig = getLunaConfig();
export default lunaConfig;
